import { AngularDotcodesService } from './angular-dotcodes.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { AngularDotcodesComponent } from './angular-dotcodes.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { DotcodesSelectComponent } from './dotcodes-select/dotcodes-select.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DotcodePipe } from './dotcode.pipe';
import { Config } from './models/config';

@NgModule({
  imports: [HttpClientModule, CommonModule, FormsModule
  ],
  declarations: [AngularDotcodesComponent, DotcodesSelectComponent, DotcodePipe],
  exports: [AngularDotcodesComponent, DotcodesSelectComponent, DotcodePipe]
})
export class AngularDotcodesModule {
  static forRoot(config: Config): ModuleWithProviders {
    return {
      ngModule: AngularDotcodesModule,
      providers: [AngularDotcodesService,
        { provide: 'config', useValue: config }
      ]
    };
  }
}
